import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: .5rem;
    padding: .25rem .5rem 0;
    margin-bottom: .25rem;
  }
`;

export default function MobileHeader({ left, right }: { left?: React.ReactNode; right?: React.ReactNode }) {
  return (
    <Container>
      <div>{left}</div>
      <div>{right}</div>
    </Container>
  );
}
